module.exports = __webpack_public_path__ + "static/image/service/pc/dilly.ver2_0_2.png?1d31551b";